// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3LtLg","checkboxCol":"Table_checkboxCol__1n_La","emailCol":"Table_emailCol__3rJGa","actionCol":"Table_actionCol__3Lpeb"};